<script>
import { loadEnum } from "@/utils/enum";
export default {
    created() {
        this.singleSignOn();
    },
    render: function (h) {
        return h() // avoid warning message
    },
    data() {
        return {
            isLoading: false,
        }
    },
    methods: {
        async singleSignOn() {
            try {
                if (this.isLoading) return;
                const { params, query } = this.$route;
                //解析登录凭证信息
                const auth = JSON.parse(decodeURIComponent(query.auth));
                console.log(auth, 'authauthauth')
                this.isLoading = true
                // auth.username = '陈有志'
                await this.$store.dispatch('user/singleSignOn', auth)
                this.isLoading = false
                // 加载枚举信息
                loadEnum()
                console.log('进来了', this.$route)
                const routeQuery = JSON.parse(JSON.stringify(query))
                delete routeQuery.auth
                delete routeQuery.redirect
                this.$router.replace({ path: query.redirect, query: routeQuery })
            } catch (error) {
                this.isLoading = false
            }
        }
    }
}
</script>
